import React from 'react';
import { cn } from 'src/lib/utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';

const AppSelect = ({
  options = [],
  value,
  onValueChange,
  placeholder,
  disabled = false,
  error = false,
  className,
  contentClassName,
  id,
  open,
  onOpenChange,
}) => (
  <Select
    value={value}
    onValueChange={onValueChange}
    disabled={disabled}
    open={open}
    onOpenChange={onOpenChange}
  >
    <SelectTrigger
      id={id}
      className={cn(
        'rounded-lg bg-card text-[13px] text-foreground-strong border-input',
        'placeholder:text-muted-foreground [&_[data-placeholder]]:text-muted-foreground',
        'focus:border-primary focus:ring-[3px] focus:ring-primary/[0.08] focus:ring-offset-0',
        // Error state
        error &&
          'border-destructive focus:border-destructive focus:ring-destructive/[0.08]',
        className
      )}
    >
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent
      position="popper"
      sideOffset={4}
      className={cn(
        // DS Â§5.11 dropdown: 10px radius, --border, deep shadow
        'rounded-[10px] border-input shadow-[0_10px_30px_rgba(0,0,0,0.10),0_1px_4px_rgba(0,0,0,0.06)]',
        contentClassName
      )}
    >
      {options.map((opt) => (
        <SelectItem
          key={opt.value}
          value={opt.value}
          className={cn(
            // DS Â§5.11 items: 13px, --text, 7px radius, 10px vertical padding
            'text-[13px] text-foreground-strong rounded-[7px] py-[10px]',
            // DS Â§5.11 item hover: brand-light bg
            'focus:bg-brand-bg-subtle focus:text-foreground-strong'
          )}
        >
          {opt.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default AppSelect;
